/**
 * Calculates the bounding box for a set of points.
 * @param {Array<{lat: number, lng: number}>} points - Array of points.
 * @returns {Object} Bounds object with min/max lat/lng.
 */
export function calculateBounds(points) {
  if (!points || points.length === 0) {
    return { minLat: null, maxLat: null, minLng: null, maxLng: null };
  }

  let minLat = points[0].lat;
  let maxLat = points[0].lat;
  let minLng = points[0].lng;
  let maxLng = points[0].lng;

  for (const point of points) {
    minLat = Math.min(minLat, point.lat);
    maxLat = Math.max(maxLat, point.lat);
    minLng = Math.min(minLng, point.lng);
    maxLng = Math.max(maxLng, point.lng);
  }

  return { minLat, maxLat, minLng, maxLng };
}

export const calculateTracksBounds = (boundsArray) => {
  if (!boundsArray || boundsArray.length === 0) {
    // Handle empty or invalid input
    return {
      minLat: undefined,
      maxLat: undefined,
      minLng: undefined,
      maxLng: undefined,
    };
  }

  let overallMinLat = Infinity;
  let overallMaxLat = -Infinity;
  let overallMinLng = Infinity;
  let overallMaxLng = -Infinity;

  boundsArray.forEach((bounds) => {
    // For the overall minimum latitude, we take the minimum of all 'minLat' values
    overallMinLat = Math.min(overallMinLat, bounds.minLat);
    // For the overall maximum latitude, we take the maximum of all 'maxLat' values
    overallMaxLat = Math.max(overallMaxLat, bounds.maxLat);

    // For the overall minimum longitude, we take the minimum of all 'minLng' values
    overallMinLng = Math.min(overallMinLng, bounds.minLng);
    // For the overall maximum longitude, we take the maximum of all 'maxLng' values
    overallMaxLng = Math.max(overallMaxLng, bounds.maxLng);
  });

  return {
    minLat: overallMinLat,
    maxLat: overallMaxLat,
    minLng: overallMinLng,
    maxLng: overallMaxLng,
  };
};
